import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
type LegalTab = 'terms' | 'privacy';
export function Footer() {
  const [legalOpen, setLegalOpen] = useState(false);
  const [legalTab, setLegalTab] = useState<LegalTab>('terms');
  const openLegal = (tab: LegalTab) => {
    setLegalTab(tab);
    setLegalOpen(true);
  };
  return <>
      <footer className="w-full bg-navy border-t border-white/10 py-6 px-6 text-center" data-id="element-9">
        <div className="max-w-4xl mx-auto" data-id="element-10">
          <p className="font-serif text-gold text-lg mb-1" data-id="element-11">
            Silencia a la "Mamá Juez"
          </p>
          <p className="font-sans text-white/40 text-sm mb-3" data-id="element-12">
            © 2026 · Todos los derechos reservados
          </p>
          <div className="flex items-center justify-center gap-4 text-xs font-sans" data-id="element-13">
            <button onClick={() => openLegal('terms')} className="text-white/50 hover:text-gold transition-colors underline underline-offset-2" data-id="element-14">
              Términos y Condiciones
            </button>
            <span className="text-white/30" data-id="element-15">|</span>
            <button onClick={() => openLegal('privacy')} className="text-white/50 hover:text-gold transition-colors underline underline-offset-2" data-id="element-16">
              Política de Privacidad
            </button>
          </div>
        </div>
      </footer>

      <LegalModal isOpen={legalOpen} onClose={() => setLegalOpen(false)} initialTab={legalTab} data-id="element-17" />
    </>;
}